import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "How does the pricing work?",
        a: "Your AI estimate is an indicative ballpark range. Once you submit, we match you with a trusted local repairer in your area who reviews the details (and your photos) and confirms the exact price — with no obligation to go ahead.",
    },
    {
        q: "How accurate is the AI estimate?",
        a: "It's a quick ballpark to set expectations. We deliberately keep the range wide so there are no nasty surprises — your local repairer confirms the exact price before any work starts.",
    },
    {
        q: "Who actually does the repair?",
        a: "We connect you with a vetted local panel & paint specialist suited to your job and region. You deal with a quality repairer nearby, and we help get you matched quickly.",
    },
    {
        q: "Will the repairer work with my insurance?",
        a: "Yes — our repairers are approved by the major NZ insurers and can manage the claim end-to-end if you'd like, including the paperwork and assessor visits.",
    },
    {
        q: "Is the AI estimate really free?",
        a: "Completely free with no obligation. Use it as many times as you like — we'd rather you make an informed decision than feel pressured into anything.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="py-20 md:py-28 bg-carbon border-t border-white/5"
        >
            <div className="max-w-4xl mx-auto px-6 md:px-10">
                <div className="mb-12">
                    <p className="uppercase text-xs tracking-[0.3em] text-electric mb-3">
                        Common questions
                    </p>
                    <h2 className="font-display text-4xl md:text-5xl text-white font-bold leading-[1.05] tracking-tight">
                        Got questions? Good — we&rsquo;ve got answers.
                    </h2>
                </div>

                <Accordion
                    type="single"
                    collapsible
                    className="border-t border-white/10"
                    data-testid="faq-accordion"
                >
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-b border-white/10"
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="py-6 text-left text-lg md:text-xl font-display text-white hover:text-electric hover:no-underline">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-slate-400 text-base leading-relaxed pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
